//Action Types
export var ADD_ON_SERVICES_RESET_ACTION_TYPE = "ADD_ON_SERVICES_RESET";
export var ADD_ON_SERVICES_FETCH_START_ACTION_TYPE = "ADD_ON_SERVICES_FETCH_START";
export var ADD_ON_SERVICES_FETCH_SUCCESS_ACTION_TYPE = "ADD_ON_SERVICES_FETCH_SUCCESS";
export var ADD_ON_SERVICES_SAVE_START_ACTION_TYPE = "ADD_ON_SERVICES_SAVE_START";
export var ADD_ON_SERVICES_SAVE_SUCCESS_ACTION_TYPE = "ADD_ON_SERVICES_SAVE_SUCCESS";
export var ADD_ON_SERVICES_DELETE_START_ACTION_TYPE = "ADD_ON_SERVICES_DELETE_START";
export var ADD_ON_SERVICES_DELETE_SUCCESS_ACTION_TYPE = "ADD_ON_SERVICES_DELETE_SUCCESS";
export var ADD_ON_SERVICES_CHANGE_STATE_START_ACTION_TYPE = "ADD_ON_SERVICES_CHANGE_STATE_START";
export var ADD_ON_SERVICES_CHANGE_STATE_SUCCESS_ACTION_TYPE = "ADD_ON_SERVICES_CHANGE_STATE_SUCCESS";
export var ADD_ON_SERVICES_ERROR_ACTION_TYPE = "ADD_ON_SERVICES_ERROR";
